export type ValidationRule = {
  validationMessage: string;
  validate: (value: string) => boolean;
};

export const passwordValidationRules: ValidationRule[] = [
  {
    validationMessage: "At least 8 characters",
    validate: (value: string) => value.length >= 8,
  },
  {
    validationMessage: "At least 1 uppercase letter",
    validate: (value: string) => /[A-Z]/.test(value),
  },
  {
    validationMessage: "At least 1 lowercase letter",
    validate: (value: string) => /[a-z]/.test(value),
  },
  {
    validationMessage: "At least 1 number",
    validate: (value: string) => /\d/.test(value),
  },
  {
    validationMessage: "At least 1 special character",
    validate: (value: string) =>
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value),
  },
];
